import { render, staticRenderFns } from "./koshaDetail.vue?vue&type=template&id=02aa6cc4"
import script from "./koshaDetail.vue?vue&type=script&lang=js"
export * from "./koshaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02aa6cc4')) {
      api.createRecord('02aa6cc4', component.options)
    } else {
      api.reload('02aa6cc4', component.options)
    }
    module.hot.accept("./koshaDetail.vue?vue&type=template&id=02aa6cc4", function () {
      api.rerender('02aa6cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/kosha/koshaDetail.vue"
export default component.exports